/* sk8 Monster Drops, tema 360: simulador de tamanho por altura e peso.

   Ideia copiada do simulador da Traction (assets/traction-tamanho.js, 22/09/2026),
   com a regra recalculada para a tabela de medidas da SK8. Nada daqui depende da Traction.

   A REGRA. A camiseta tem duas exigencias e vale a maior delas:
     COMPRIMENTO segue a altura: a peca precisa cobrir ALTURA x FRACAO_DA_ALTURA.
     LARGURA segue o volume do corpo: a largura da peca (a da tabela, na cintura) precisa
     ser pelo menos (peito estimado / 2) + FOLGA_LARGURA.
   Os numeros de comprimento e largura NAO ficam aqui: saem dos data-atributos do
   snippet sk8-tamanho.liquid, que recebe a mesma tabela do product.liquid. Mudou a
   tabela la, o simulador acompanha sozinho.
   Peito estimado = 48 + 0,68 x peso + 0,1 x (altura - 170), a mesma aproximacao da
   Traction. Caimento: "Justo" desce um tamanho, "Largo" sobe um.

   Calibragem da SK8 (decisao de produto, a confirmar com o Vini): FRACAO_DA_ALTURA = 0,42.
   A Traction usa 0,44 porque a camiseta dela mede 72,5 a 83,5 cm. Na SK8 o P ao GG medem
   70 a 75 cm, entao 0,44 mandaria G1 (81 cm, largura 64) para qualquer pessoa acima de
   1,70 m, peca grande demais. Com 0,42 o GG cobre ate 1,78 m e o G1 serve de 1,79 m a
   1,92 m. FOLGA_LARGURA = 4 cm, igual a Traction.

   Eventos no document, para outras frentes (por exemplo as falas do vendedor):
     sk8:simulador { acao: "abrir" }
     sk8:simulador { acao: "fechar" }
     sk8:simulador { acao: "recomendou", tamanho, tamanhoIndicado, altura, peso, caimento, esgotado }
   "tamanho" e o que ficou marcado no seletor de compra; "tamanhoIndicado" e o que a conta
   indicou. Eles diferem so quando o indicado esta esgotado nesta peca. */
(function () {
  "use strict";

  var FRACAO_DA_ALTURA = 0.42;
  var FOLGA_LARGURA = 4;

  function peitoEstimado(altura, peso) { return 48 + 0.68 * peso + 0.1 * (altura - 170); }

  function lista(texto) { return (texto || "").split(",").map(function (s) { return s.trim(); }).filter(Boolean); }

  function montar(bloco) {
    if (bloco.dataset.simMontado) return;
    bloco.dataset.simMontado = "1";

    var tam = lista(bloco.getAttribute("data-tamanhos"));
    var comp = lista(bloco.getAttribute("data-comprimentos")).map(Number);
    var larg = lista(bloco.getAttribute("data-larguras")).map(Number);
    if (!tam.length || tam.length !== comp.length || tam.length !== larg.length) return;

    var altura = bloco.querySelector("#sim-altura"), peso = bloco.querySelector("#sim-peso");
    var saida = bloco.querySelector("[data-sim-saida]"), letra = bloco.querySelector("[data-sim-letra]");
    var leitura = bloco.querySelector("[data-sim-leitura]");
    var opcoes = Array.prototype.slice.call(bloco.querySelectorAll(".sim-opcao"));
    var abrir = Array.prototype.slice.call(document.querySelectorAll("[data-abrir-simulador]"));
    var form = document.getElementById("form-compra");
    var caimento = "regular", ultimo = "", temporizador = null;

    function emitir(detalhe) { document.dispatchEvent(new CustomEvent("sk8:simulador", { detail: detalhe })); }

    function menorQueAtende(precisa, medidas) {
      for (var i = 0; i < medidas.length; i++) if (medidas[i] >= precisa) return i;
      return medidas.length - 1;
    }

    function indicar(a, p, fit) {
      if (!(a >= 140) || !(p >= 40)) return null;
      var i = Math.max(
        menorQueAtende(a * FRACAO_DA_ALTURA, comp),
        menorQueAtende(peitoEstimado(a, p) / 2 + FOLGA_LARGURA, larg)
      );
      if (fit === "oversized") i = Math.min(i + 1, tam.length - 1);
      if (fit === "slim") i = Math.max(i - 1, 0);
      return i;
    }

    // Radios de tamanho da compra. Esgotado vem desabilitado.
    function radios() { return form ? Array.prototype.slice.call(form.querySelectorAll("[data-tamanho-compra] input[type=radio]")) : []; }
    function porValor(v) { return radios().filter(function (r) { return r.value === v; })[0]; }

    // Do indicado, vai para o vizinho disponivel mais proximo, preferindo o maior.
    function disponivelPerto(i) {
      for (var d = 0; d < tam.length; d++) {
        var cima = tam[i + d], baixo = tam[i - d];
        var rc = cima && porValor(cima), rb = baixo && porValor(baixo);
        if (rc && !rc.disabled) return cima;
        if (rb && !rb.disabled) return baixo;
      }
      return null;
    }

    function marcar(valor) {
      var r = porValor(valor);
      if (!r || r.disabled) return false;
      if (!r.checked) {
        r.checked = true;
        r.dispatchEvent(new Event("change", { bubbles: true }));
      }
      return true;
    }

    function limpar() {
      letra.textContent = "--";
      saida.classList.remove("tem-resultado");
      leitura.textContent = "Preencha altura e peso para ver o tamanho indicado.";
    }

    function recalcular() {
      var a = parseFloat(altura.value), p = parseFloat(peso.value);
      var i = indicar(a, p, caimento);
      if (i === null) { limpar(); ultimo = ""; return; }

      var indicado = tam[i];
      var final = disponivelPerto(i);
      var esgotado = final !== indicado;
      var marcou = final !== null && marcar(final);
      var mostrado = marcou ? final : indicado;

      letra.textContent = mostrado;
      saida.classList.add("tem-resultado");
      var texto = "Seu tamanho é <b>" + mostrado + "</b>.";
      // indicado bloqueado porque nao existe na modelagem escolhida (a Oversized vai do P ao GG), e nao por falta de estoque
      var rIndicado = porValor(indicado), labelIndicado = rIndicado && rIndicado.closest("label");
      var foraDaModelagem = !!(labelIndicado && labelIndicado.classList.contains("nao-existe"));
      if (marcou && esgotado && foraDaModelagem) texto = "O tamanho indicado é <b>" + indicado + "</b>, que não existe nesta modelagem. O mais próximo é o <b>" + final + "</b>, já marcado acima.";
      else if (marcou && esgotado) texto = "O tamanho indicado é <b>" + indicado + "</b>, mas está esgotado nesta camiseta. O mais próximo disponível é o <b>" + final + "</b>, já marcado acima.";
      else if (marcou) texto += " Já deixamos marcado acima.";
      else if (final === null) texto = "O tamanho indicado é <b>" + indicado + "</b>, mas esta camiseta está esgotada.";
      // Acima do que o maior tamanho cobre em comprimento, avisar antes da compra.
      if (a * FRACAO_DA_ALTURA > comp[comp.length - 1]) texto += " Com essa altura, até o " + tam[tam.length - 1] + " pode ficar curto. É o maior tamanho que temos.";
      leitura.innerHTML = texto;

      var chave = [mostrado, indicado, caimento].join("|");
      if (chave !== ultimo) {
        ultimo = chave;
        emitir({ acao: "recomendou", tamanho: mostrado, tamanhoIndicado: indicado, altura: a, peso: p, caimento: caimento, esgotado: esgotado });
      }
    }

    function agendar() { clearTimeout(temporizador); temporizador = setTimeout(recalcular, 250); }

    function abrirPainel(foco) {
      var jaAberto = !bloco.hidden;
      bloco.hidden = false;
      abrir.forEach(function (b) { b.setAttribute("aria-expanded", "true"); });
      if (!jaAberto) emitir({ acao: "abrir" });
      if (foco) {
        var calmo = window.matchMedia && window.matchMedia("(prefers-reduced-motion: reduce)").matches;
        bloco.scrollIntoView({ behavior: calmo ? "auto" : "smooth", block: "nearest" });
        altura.focus({ preventScroll: true });
      }
    }
    function fecharPainel() {
      if (bloco.hidden) return;
      bloco.hidden = true;
      abrir.forEach(function (b) { b.setAttribute("aria-expanded", "false"); });
      emitir({ acao: "fechar" });
      if (abrir[0]) abrir[0].focus({ preventScroll: true });
    }

    abrir.forEach(function (b) {
      b.addEventListener("click", function () { if (bloco.hidden) abrirPainel(true); else fecharPainel(); });
    });
    var fechar = bloco.querySelector("[data-sim-fechar]");
    if (fechar) fechar.addEventListener("click", fecharPainel);
    bloco.addEventListener("keydown", function (e) { if (e.key === "Escape") fecharPainel(); });

    // Enter nos campos nao pode enviar o formulario de compra: so fecha o teclado.
    [altura, peso].forEach(function (c) {
      c.addEventListener("keydown", function (e) { if (e.key === "Enter") { e.preventDefault(); c.blur(); recalcular(); } });
      c.addEventListener("input", agendar);
    });

    opcoes.forEach(function (op) {
      op.addEventListener("click", function () {
        caimento = op.getAttribute("data-fit") || "regular";
        opcoes.forEach(function (o) { o.setAttribute("aria-checked", String(o === op)); });
        recalcular();
      });
      op.addEventListener("keydown", function (e) {
        var i = opcoes.indexOf(op);
        var prox = e.key === "ArrowRight" || e.key === "ArrowDown" ? i + 1 : e.key === "ArrowLeft" || e.key === "ArrowUp" ? i - 1 : null;
        if (prox === null) return;
        e.preventDefault();
        var alvo = opcoes[(prox + opcoes.length) % opcoes.length];
        alvo.focus();
        alvo.click();
      });
    });

    // Exposto para conferir a regra sem abrir o navegador.
    window.sk8IndicarTamanho = function (a, p, fit) { var i = indicar(a, p, fit || "regular"); return i === null ? null : tam[i]; };
  }

  function iniciar() { document.querySelectorAll("[data-sk8-simulador]").forEach(montar); }
  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", iniciar); else iniciar();
})();
